module.exports = __webpack_public_path__ + "static/img/5.8d9ab1a7.png";